import React, { useState, useEffect } from 'react';
import copyIcon from '../images/copy_icon.png';
import updateIcon from '../images/update_icon.png';

function PasswordDisplay({ password, onGeneratePassword }) {
  const [firstRow, setFirstRow] = useState('');
  const [secondRow, setSecondRow] = useState('');

  useEffect(() => {
    if (password.length > 20) {
      const midpoint = Math.ceil(password.length / 2);
      setFirstRow(password.slice(0, midpoint));
      setSecondRow(password.slice(midpoint));
    } else {
      setFirstRow(password);
      setSecondRow('');
    }
  }, [password]);

  const copyPassword = () => {
    navigator.clipboard.writeText(password);
    alert('Password copied to clipboard!');
  };

  return (
    <div className="password-display">
      <div className="password-container">
        <div className="password-text">
          <div>{firstRow}</div>
          {secondRow && <div>{secondRow}</div>}
        </div>
      </div>
      <hr className="password-divider" />
      <div className="password-actions">
        <button onClick={copyPassword} aria-label="Copy password">
          <img src={copyIcon} alt="Copy" className="icon" />
        </button>
        <button onClick={onGeneratePassword} aria-label="Generate new password">
          <img src={updateIcon} alt="Generate" className="icon" />
        </button>
      </div>
    </div>
  );
}

export default PasswordDisplay;